import FormHeader from "../../dms_common/FormHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CreateSummaryCard from "./CreateSummaryCard";
import Checkout from "../Checkout";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import {
  fetchLoadoutConfigs,
  setLoadoutConfig,
} from "../pre-seller/PresellerLoadoutService";
import { GenericModal, loadoutCartState } from "./types";
import {
  getGenericModalProps,
  initialGenericModalProps,
} from "../LoadoutUtils";
import CustomGenericModal from "../../dms_common/CustomGenericModal";
import { Loader } from "../../loader/Loader";
import { initialLoadoutConfigState } from "../../../stateManagement/reducers/presellerLoadout";

const dummyVehicleOption = {
  vehicleId: "",
  vehicleNumber: "",
  vehicleType: "",
  vehicleCapacityKG: 0,
  vehicleCapacityCubicFeet: 0,
};

export default function ReviewLoadout() {
  const location: any = useLocation();
  const { loadNumber } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart: loadoutCartState = useSelector(
    (state: any) => state.presellerLoadoutState
  );
  const [displaySummary, setDisplaySummary] = useState(false);
  const [loader, setLoader] = useState(true);
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(
    initialGenericModalProps
  );

  const fetchConfigs = useCallback(async () => {
    try {
      setLoader(true);
      if (
        JSON.stringify(cart?.loadoutConfig) ===
        JSON.stringify(initialLoadoutConfigState)
      ) {
        const loadoutConfigValue = await fetchLoadoutConfigs("loadoutConfigs");
        setLoadoutConfig(loadoutConfigValue, dispatch);
      }
    } catch (error) {
      setGenericModalProps(
        getGenericModalProps("error", "Failed to fetch loadout configurations.")
      );
    } finally {
      setLoader(false);
    }
  }, [cart?.loadoutConfig, dispatch]);

  useEffect(() => {
    fetchConfigs();

    const fetchData = async () => {
      const displayLoadoutSummaryValue = await fetchLoadoutConfigs(
        "loadoutConfigs"
      );
      if (cart?.preseller) {
        setDisplaySummary(
          displayLoadoutSummaryValue?.Preseller?.DisplayLoadSummary === true &&
            displayLoadoutSummaryValue?.Preseller?.EnableVehicleAssignment
        );
      } else {
        setDisplaySummary(
          displayLoadoutSummaryValue?.Rsu?.DisplayLoadSummary === true &&
            displayLoadoutSummaryValue?.Rsu?.EnableVehicleAssignment
        );
      }
    };
    fetchData();
  }, []);

  const onLoadoutClick = () => {
    navigate("/dashboard/delivery/loadouts");
    dispatch({ type: "RESET_PRESELLER_LOADOUT" });
  };

  const handleNavigation = () => {
    const basePath = loadNumber
      ? `/dashboard/delivery/loadouts/preseller/viewLoadout/${loadNumber}`
      : "/dashboard/delivery/loadouts/preseller";

    navigate(basePath, {
      state: {
        alreadySelectedVehicle: location?.state?.selectedVehicle,
        alreadyConsumedVehicleCapacity:
          location?.state?.consumedVehicleCapacity,
        ...(loadNumber && {
          row: {
            salesmanId: cart?.cartData?.loadout?.SalesMan,
            vehicleId: cart?.cartData?.loadout?.Vehicle?.vehicleId,
          },
        }),
      },
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "11px 15px 10px 15px",
        height: "100%",
        overflowY: "auto",
      }}
      className="manage_loadout_parent"
    >
      {loader ? (
        <Loader sx={{ position: "absolute", top: "55%" }} />
      ) : (
        <>
          <CustomGenericModal
            type={genericModalProps?.type}
            message={genericModalProps?.message}
            leftButtonText={genericModalProps?.leftButtonText}
            rightButtonText={genericModalProps?.rightButtonText}
            modalOpen={genericModalProps?.open}
            onLeftButtonClick={genericModalProps?.onLeftButtonClick}
            onRightButtonClick={genericModalProps?.onRightButtonClick}
            onClose={() => setGenericModalProps(initialGenericModalProps)}
          />
          <FormHeader
            parentLabel={"Loadout"}
            label={loadNumber ? loadNumber : "Create New Loadout"}
            label1Click={handleNavigation}
            childLabel={"Review loadout"}
            goBackToParent={handleNavigation}
            childLableCaseClick={onLoadoutClick}
            backButtonClick={handleNavigation}
          />
          {displaySummary && (
            <CreateSummaryCard
              title="Loadout Summary"
              box={
                location?.state?.selectedVehicle
                  ? [
                      location?.state?.selectedVehicle,
                      location?.state?.consumedVehicleCapacity ??
                        dummyVehicleOption,
                      {
                        ...dummyVehicleOption,
                        vehicleCapacityKG:
                          (location?.state?.selectedVehicle
                            ?.vehicleCapacityKG ?? 0) -
                          (location?.state?.consumedVehicleCapacity
                            ?.vehicleCapacityKG ?? 0),
                        vehicleCapacityCubicFeet:
                          (location?.state?.selectedVehicle
                            ?.vehicleCapacityCubicFeet ?? 0) -
                          (location?.state?.consumedVehicleCapacity
                            ?.vehicleCapacityCubicFeet ?? 0),
                      },
                    ]
                  : [dummyVehicleOption, dummyVehicleOption, dummyVehicleOption]
              }
            />
          )}
          <Checkout
            displaySummary={
              cart?.preseller
                ? cart?.loadoutConfig?.displayPresellerSummary === true &&
                  cart?.loadoutConfig?.enableVehicleAssignment === true
                : cart?.loadoutConfig?.displayRsuSummary === true &&
                  cart?.loadoutConfig?.enableVehicleAssignment === true
            }
          />
        </>
      )}
    </div>
  );
}
